// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"223baef7","953":"cc54d8c9"}[chunkId] + ".chunk.js";
};